import {useState, useEffect} from 'react'
import { PageTitle, usePageData } from '../../../_metronic/layout/core'
import { SwitchLTL } from '../../components/LTLandVolumeTLPages/SwitchLTL';
import { useFormik } from 'formik';
import { CountryOptions } from '../../data/CountryOptions';
import ZipcodesWithCountry from '../../components/LTLandVolumeTLPages/ZipcodesWithCountry';
import { UserModel } from '../../modules/auth/models/UserModel';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { RootState } from '../../../setup/redux/RootReducer';
import FreightInformation from '../../components/LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformation';
import { FreightTotals } from '../../components/LTLandVolumeTLPages/FreightInfo/FreightTotals';
import { v4 as uuidv4 } from 'uuid';
import SelectUOM from '../../components/LTLandVolumeTLPages/FreightInfo/SelectUOM';
import * as Yup from "yup"
import DateInput from '../../components/LTLandVolumeTLPages/DateInput';
import axios from 'axios';
import { format } from 'date-fns';
import { OriginOrDestinationObject, RowTableObject } from './models';
import { actionTypes } from '../../modules/auth/redux/PagesRedux';
import { RatesTable } from '../../components/LTLandVolumeTLPages/Tables/RatesTable/RatesTable';
import Accessorials from '../../components/LTLandVolumeTLPages/AccesorialsComponent/Accessorials';
import HistorySelect from '../../components/LTLandVolumeTLPages/HistoryComponent/HistorySelect';
import { useParams } from 'react-router-dom';
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall';
import { marginSize } from '../../helpers/marginSize';
import { TypeOptions } from '../../data/TypeOptions';
import ConfirmTimedOutVendorsModal from '../../components/LTLandVolumeTLPages/Modals/ConfirmTimedOutVendorsModal';
// import { getRates } from '../../helpers/getRates';
import { getRatesWithLimit } from '../../helpers/getRatesWithLimit';
import { keepWaitingVendors } from '../../helpers/keepWaitingVendors';
import NoVendorsSetUpModal from '../../components/Modals/NoVendorsSetUpModal';
import InsuranceRequiredModal from '../book/NewBooking/InsuranceRequiredModal';
import EquipmentServiceModal from '../../components/Volume/TLPage/EquipmentServiceModal';
import ErrorsInPageModal from '../book/NewBooking/ErrorsInPageModal';
import { getCountriesWithoutZipcodes } from '../../constants/countries';

interface freightErrors {
  qty: string,
  weight: string,
  nmfc: string,
  L: string,
  W: string,
  H: string
}

let cancelToken = axios.CancelToken
let source = cancelToken.source()
const GET_LNFT = '/api/v1/tools/lnft'
const GET_LANEDISTANCE = '/api/v1/tools/distancematrix'
const GET_QUOTE = '/api/v1/database/quote'
const CREATE_QUOTE_REDKIK = '/api/v1/tools/redkik/createquote'

export const GetQuote = () => {
  const resetValues = useSelector<RootState>(({pages}) => pages?.resetValues) as boolean
  const [openHazContactModal, setOpenHazContactModal] = useState(false)
  const [origin, setOrigin] = useState<OriginOrDestinationObject>({
    City: "",
    Country: "",
    Name: "",
    State: "",
    Zipcode: "",
    isSL: false,
    isZipcode: false,
    id: null
  })
  const [destination, setDestination] = useState<OriginOrDestinationObject>({
    City: "",
    Country: "",
    Name: "",
    State: "",
    Zipcode: "",
    isSL: false,
    isZipcode: false,
    id: null
  })
  const [rates, setRates] = useState([] as Array<RowTableObject>)
  const [linearProgress, setLinearProgress] = useState(0);
  const [showTable, setShowTable] = useState(false)
  const [touchedPickupDate, setTouchedPickupDate] = useState(false)
  const [zipcodeOrigin, setZipcodeOrigin] = useState('')
  const [zipcodeDestination, setZipcodeDestination] = useState('')
  const [selectedAcc, setSelectedAcc] = useState([]);
  const [ratesStopped, setRatesStopped] = useState(false)
  const [needRateType, setNeedRateType] = useState(false)
  const [laneDistance, setLaneDistance] = useState("")
  const [actionClicked, setActionClicked] = useState(false)
  const [LNFT, setLNFT] = useState(0)
  const dispatch = useDispatch()
  let {setHistoryElement} = usePageData()
  let { id } = useParams();
  const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
  const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
  const [selectedUn, setSelectedUn] = useState([])
  const [enabledVendors, setEnabledVendors] = useState([])
  const [vendorsProcessed, setVendorsProcessed] = useState('0')
  const [vendorsTimedOut, setVendorsTimedOut] = useState([])
  const [openConfirmTimedOutModal, setOpenConfirmTimedOutModal] = useState(false)
  const [openNoVendorsSetUpModal, setOpenNoVendorsSetUpModal] = useState(false)
  const [openInsuranceRequiredModal, setOpenInsuranceRequiredModal] = useState(false)
  const [closeAcc, setCloseAcc] = useState(false)
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [openEquipmentServiceModal, setOpenEquipmentServiceModal] = useState(false)
  const [openErrorsInPageModal, setOpenErrorsInPageModal] = useState(false)
  const [loadingDispatchShipment, setLoadingDispatchShipment] = useState(false)
  const [isAccesorialsOpenend, setIsAccesorialsOpenend ] = useState(false)

  const initialValues = {
    VOL: true,
    smallPack: true,
    LTL: true,
    AIR: true,
    expedite: true,
    origin: {
      City: "",
      Country: "",
      Name: "",
      State: "",
      Zipcode: "",
      isSL: false,
      isZipcode: false,
      id: null
    },
    destination: {
      City: "",
      Country: "",
      Name: "",
      State: "",
      Zipcode: "",
      isSL: false,
      isZipcode: false,
      id: null
    },
    pickupDate: new Date(),
    accessorials: {
      origin: [],
      destination: [],
      other: []
    },
    freightInfo: [{
      id: uuidv4(),
      overrideClass: true,
      qty: '',
      dimType: {
        name: "PALLET",
        value: "PLT"
      },
      STC: '',
      weight: '',
      each: 'Each',
      L: '',
      W: '',
      H: '',
      class: '',
      commodity: '',
      nmfc: '',
      weightus: '',
      Lus: '',
      Wus: '',
      Hus: '',
      totalCft: '',
      hazmat: false,
      UN: '',
      stack: null,
      volume: ''
    }],
    freightInfoUOM: {
      value: user?.defaultUOM,
      oldValue: ''
    },
    freightInfoTotals: {
      totalPieces: 0,
      totalWeight: 0,
      totalCFT: 0,
      totalDensity: 0,
      symbol: user.defaultUOM === 'US' ? 'lbs' : 'kgs'
    },
    insuranceAmount: null,
    insuranceFreight: false,
    insuranceAddOn: false,
    commodityInsurance: '',
    redkikQuoteId: null,
    coverTypeInsurance: null,
  }

  Yup.addMethod<Yup.DateSchema>(Yup.date, "lessThanToday", function (message) {
    return this.test("test-name", message, function(value: any) {
      const { path, createError } = this
      return( value < new Date().setHours(0,0,0,0) ? createError({message, path}) : value )
    })
  })

  Yup.addMethod<Yup.StringSchema>(Yup.string, "moreThanZero", function (message) {
    return this.test("test-name", message, function(value: any) {
      const { path, createError } = this
      return( typeof value === 'string' ? (parseInt(value) ? value : createError({message, path})) : value > 0 ? value : createError({message, path}))
    })
  })

  const validationSchema = (values) => {
    return (
      Yup.object().shape({
      VOL: Yup.boolean(),
      smallPack: Yup.boolean(),
      LTL: Yup.boolean(),
      AIR: Yup.boolean(),
      origin: Yup.object({
        City: Yup.string().required('Required'),
        Country: Yup.string().required('Required'),
        Name: Yup.string(),
        State: values?.origin?.State ? Yup.string().required('Required') : Yup.string().nullable(),
        Zipcode: getCountriesWithoutZipcodes().includes(values?.origin?.Country) ? Yup.string().nullable() : Yup.string().required('Required'),
        isSL: Yup.boolean(),
        isZipcode: Yup.boolean(),
        isCity: Yup.boolean()
      }),
      destination: Yup.object({
        City: Yup.string().required('Required'),
        Country: Yup.string().required('Required'),
        Name: Yup.string(),
        State: values?.destination?.State ? Yup.string().required('Required') : Yup.string().nullable(),
        Zipcode: getCountriesWithoutZipcodes().includes(values?.destination?.Country) ? Yup.string().nullable() : Yup.string().required('Required'),
        isSL: Yup.boolean(),
        isZipcode: Yup.boolean(),
        isCity: Yup.boolean()
      }),
      freightInfo: Yup.array().when(['VOL', 'smallPack', 'LTL', 'AIR'], {
        is: (VOL, smallPack, LTL, AIR) => {
          return (VOL && (LTL === false) && (smallPack === false) && (AIR === false))
        },
        then: Yup.array().of(Yup.object().shape({
          qty: Yup.string().required("Required"),
          weight: Yup.string().required("Required"),
          L: Yup.string().nullable(),
          W: Yup.string().nullable(),
          H: Yup.string().nullable(),
          nmfc: Yup.string().test('length', 'Must be 8 numbers or empty', (value) => {
            if(value && /\s/g.test(value)){
              return false
            }else{
              return true
            }
          })
        })),
        otherwise: Yup.array().of(Yup.object().shape({
          qty: Yup.string().required("Required"),
          weight: Yup.string().required("Required"),
          volume: Yup.string().nullable(),
          L: user?.requireDimensions ? Yup.string().when('volume', {
            is: (volume) => !volume || parseFloat(volume) <= 0,
            then: (Yup.string() as any).moreThanZero('Required').required(),
            otherwise: Yup.string().nullable()
          }) : Yup.string().nullable(),
          W: user?.requireDimensions ? Yup.string().when('volume', {
            is: (volume) => !volume || parseFloat(volume) <= 0,
            then: (Yup.string() as any).moreThanZero('Required').required(),
            otherwise: Yup.string().nullable()
          }) : Yup.string().nullable(),
          H: user?.requireDimensions ? Yup.string().when('volume', {
            is: (volume) => !volume || parseFloat(volume) <= 0,
            then: (Yup.string() as any).moreThanZero('Required').required(),
            otherwise: Yup.string().nullable()
          }) : Yup.string().nullable(),
          nmfc: Yup.string().test('length', 'Must be 8 numbers or empty', (value) => {
            if(value && /\s/g.test(value)){
              return false
            }else{
              return true
            }
          })
        }))
      }),
      pickupDate: (Yup.date() as any).lessThanToday('Pickup date cannot be in the past').required()
      })
    )
  }

  const formik = useFormik({
    initialValues,
    validationSchema: () => validationSchema(formik.values),
    validateOnChange: false,
    onSubmit: (values) => {
      if(!values.VOL && !values.LTL && !values.smallPack && !values.AIR && !values.expedite){
        setNeedRateType(true)
        setShowTable(false)
        setRates([])
        setLinearProgress(0)
        setRatesStopped(false)
        return
      }

      if([...formik?.values?.accessorials?.origin, ...formik?.values?.accessorials?.destination, ...formik?.values?.accessorials?.other].filter(a => a.code === 'INS')?.length && !formik?.values?.insuranceAmount) {
        setOpenInsuranceRequiredModal(true)
      }else{
        let enabledVendorsFiltered = user.enabledVendors.filter(vendor => ((values.VOL && vendor.type === 'VOL') || (values.LTL && (vendor.type === 'LTL' || vendor.type === '3PL')) || (values.smallPack && vendor.type === 'SP') || (values.AIR && (vendor.type === 'INTL' || vendor.type === 'AIR')) || (values.expedite && vendor.type === 'GRE')))

        setNeedRateType(false)
        source = cancelToken.source()

        let subVendors = []
        if(!enabledVendorsFiltered.length){
          if(values.smallPack){
            user.enabledVendors.forEach(vendor => {
              let subVendorsSP = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'SP')
              if(subVendorsSP.length){
                subVendors.push(...subVendorsSP)
                enabledVendorsFiltered = subVendors
              }
            })
          }

          if(values.expedite){
            user.enabledVendors.forEach(vendor => {
              let subVendorsSP = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'GRE')
              if(subVendorsSP.length){
                subVendors.push(...subVendorsSP)
                enabledVendorsFiltered = subVendors
              }
            })
          }

          if(values.LTL){
            user.enabledVendors.forEach(vendor => {
              let subVendorsLTL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'LTL' || subVendor?.carrierType === '3PL')
              if(subVendorsLTL.length){
                subVendors.push(...subVendorsLTL)
                enabledVendorsFiltered = subVendors
              }
            })
          }

          if(values.VOL){
            user.enabledVendors.forEach(vendor => {
              let subVendorsVOL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'VOL')
              if(subVendorsVOL.length){
                subVendors.push(...subVendorsVOL)
                enabledVendorsFiltered = subVendors
              }
            })
          }

          if(values.AIR){
            user.enabledVendors.forEach(vendor => {
              let subVendorsAIR = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'INTL' || subVendor?.carrierType === 'AIR')
              if(subVendorsAIR.length){
                subVendors.push(...subVendorsAIR)
                enabledVendorsFiltered = subVendors
              }
            })
          }
        }

        if(enabledVendorsFiltered?.length){
          if(values.VOL && user.requireVolumeEquipment){
            getLNFTandDistance(values, (lnft) => {})
            setOpenEquipmentServiceModal(true)
          }else{
            getLNFTandDistance(values, (lnft, laneDistance) => {getRatesWithLimit(values, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, setShowTable, setRates, setLinearProgress, setRatesStopped, source, normalizeParams, selectedUn, "historyLTL", lnft, laneDistance)})
          }
        }else{
          setOpenNoVendorsSetUpModal(true)
        }
      }
    }
  })

  const normalizeParams = (vendorId, lnft, laneDistance) => {
    const data = formik.values

    // const numbersForInsuranceAmout = data?.insuranceAmount ? data?.insuranceAmount : ''
    // const highestInsuranceAmount = Math?.max(...numbersForInsuranceAmout)
    // const highestInsuranceAmount = numbersForInsuranceAmout
    // const indexOfHighest = numbersForInsuranceAmout?.indexOf(highestInsuranceAmount)

    return {
      vendorId: vendorId,
      originCity: data.origin.City,
      originState: data.origin.State,
      originZipcode: data.origin.Zipcode,
      originCountry: data.origin.Country,
      originIATA: data.origin.IATACode,
      destinationIATA: data.destination.IATACode,
      destinationCity: data.destination.City,
      destinationState: data.destination.State,
      destinationZipcode: data.destination.Zipcode,
      destinationCountry: data.destination.Country,
      freightInfo: JSON.stringify(
        data.freightInfo.map((freight: any, index) => {
          let selectedUnIndex = selectedUn?.filter(s => s.index === index)[0]
          return {
            qty: parseFloat(freight.qty),
            weight: parseFloat(freight.weight),
            weightType: freight.each === "Each" ? "each" : "total",
            length: parseFloat(freight.L),
            width: parseFloat(freight.W),
            height: parseFloat(freight.H),
            class: parseFloat(freight.class) || 0,
            hazmat: freight.hazmat,
            commodity: freight.commodity,
            freightsnapId: freight.freightsnapId || null,
            dimType: freight.dimType.value,
            stack: (freight.stack === 'No' || !freight.stack) ? false : true,
            stackAmount: (freight.stack === 'No' || !freight.stack) ? null : parseInt(freight.stack),
            nmfc: freight.nmfc,
            volume: parseFloat(freight.volume) || null,
            UN : freight?.UN,
            UNDescription: selectedUnIndex?.description,
            UNHAZClass:  selectedUnIndex?.HAZClass,
            UNPKGGroup: selectedUnIndex?.PKGGroup,
            UNLabels: selectedUnIndex?.labels,
          }
        })
      ),
      UOM: data.freightInfoUOM.value,
      'accessorialsList[]': [
        ...data.accessorials.origin.map(acc => acc.code),
        ...data.accessorials.destination.map(acc => acc.code),
        ...data.accessorials.other.map(acc => acc.code)
      ].join('|'),
      pickupDate: format(data.pickupDate, "yyyy-MM-dd"),
      commodityInsurance: data?.commodityInsurance ? data?.commodityInsurance  : undefined,
      insuranceAmount: data?.insuranceAmount ? data?.insuranceAmount : null,
      insuranceFreight: data.insuranceFreight ? data.insuranceFreight : false,
      insuranceAddOn: data?.insuranceAddOn ? data?.insuranceAddOn : false,
      equipment: data.equipment,
      lnft: lnft,
      laneDistance: laneDistance ?? data.laneDistance,
      redkikQuoteId: data.redkikQuoteId ? data.redkikQuoteId : null,
      coverTypeInsurance: data?.coverTypeInsurance ? data?.coverTypeInsurance : null,
    }
  }

  const getLNFTandDistance = (values, getRatesWithLimit) => {
    setLNFT(0)
    setLaneDistance("")

    const getLNFT = axios.get(GET_LNFT, {params: {
      returnLayout: false,
      companyDefaultTruck: true,
      freightInfo: JSON.stringify(
        values.freightInfo.map((freight) => {
          return {
            qty: parseFloat(freight.qty),
            weight: parseFloat(freight.weight),
            weightType: freight.each === "Each" ? "each" : "total",
            length: parseFloat(freight.L) || 0,
            width: parseFloat(freight.W) || 0,
            height: parseFloat(freight.H) || 0,
            class: parseFloat(freight.class) || 0,
            hazmat: freight.hazmat,
            commodity: freight.commodity,
            dimType: freight.dimType.value,
            stack: (freight.stack === 'No' || !freight.stack) ? false : true,
            stackAmount: (freight.stack === 'No' || !freight.stack) ? null : parseInt(freight.stack),
          }
        })
      ),
      UOM: values.freightInfoUOM.value,
    }}).then(response => response.data.data.results)

    const getDistance = axios.get(GET_LANEDISTANCE, {params: {
      'origins[]': values.origin.Zipcode,
      'destinations[]': values.destination.Zipcode,
      units: 'imperial'
    }}).then(response => response.data.data.results?.length ?  response.data.data.results[0] : "")
    
    // const getRedkikQuoteId = axios.post(CREATE_QUOTE_REDKIK, {
    //   originCity: values.origin?.City,
    //     originState: values.origin?.State,
    //     originZipcode: values.origin?.Zipcode,
    //     originCountry: values.origin?.Country,
    //     destinationCity: values.destination?.City,
    //     destinationState: values.destination?.State,
    //     destinationZipcode: values.destination?.Zipcode,
    //     destinationCountry: values.destination?.Country,
    //     commodityInsurance: values?.commodityInsurance,
    //     insuranceAmount: values?.insuranceAmount,
    //     insuranceFreight: values?.insuranceFreight,
    //     insuranceAddOn: values?.insuranceAddOn,
    //     pickupDate: new Date().toISOString().slice(0, 10),
    //     conveyanceType: "LAND"
    // }).then(response => response.data.data.results.redkikQuoteId ?  response.data.data.results.redkikQuoteId : "")

    const getRedkikQuoteId = new Promise((resolve, reject) => {
      if(user?.redkikEnabled && values?.commodityInsurance && !values.redkikQuoteId && !values.insuranceFreight) {
        axios.post(CREATE_QUOTE_REDKIK, {
          originCity: values.origin?.City,
            originState: values.origin?.State,
            originZipcode: values.origin?.Zipcode,
            originCountry: values.origin?.Country,
            destinationCity: values.destination?.City,
            destinationState: values.destination?.State,
            destinationZipcode: values.destination?.Zipcode,
            destinationCountry: values.destination?.Country,
            commodityInsurance: values?.commodityInsurance,
            insuranceAmount: values?.insuranceAmount,
            insuranceFreight: values?.insuranceFreight,
            insuranceAddOn: values?.insuranceAddOn,
            pickupDate: new Date().toISOString().slice(0, 10),
            conveyanceType: "LAND"
        }).then(response => response.data.data.results.redkikQuoteId ? setTimeout(resolve, 100, response.data.data.results.redkikQuoteId) : setTimeout(resolve, 100, ""))
      }
      else {
        setTimeout(resolve, 100, "")
      }
    })

    Promise.allSettled([getLNFT, getDistance, getRedkikQuoteId]).then(promiseValues => {
      if(promiseValues[2]?.value) {
        formik.setFieldValue('redkikQuoteId', promiseValues[2].value)
        values['redkikQuoteId'] = promiseValues[2].value
      }
      values['commodityInsurance'] = values?.commodityInsurance
      values['insuranceAmount'] = values?.insuranceAmount
      values['insuranceFreight'] = values?.insuranceFreight

      if(promiseValues[0]?.status === 'fulfilled' && promiseValues[0]?.value?.LNFT) {
        setLNFT(promiseValues[0].value.LNFT)
      }

      if(promiseValues[1]?.status === 'fulfilled' && promiseValues[1]?.value?.distance) {
        setLaneDistance(promiseValues[1].value.distance.text)
        formik.setFieldValue('laneDistance', promiseValues[1].value.distance.valueInMiles)
      }

      const lnftValue = promiseValues[0]?.status === 'fulfilled' ? promiseValues[0]?.value?.LNFT : undefined
      const laneDistanceValue = promiseValues[1]?.status === 'fulfilled' ? promiseValues[1]?.value?.distance?.valueInMiles : undefined
      getRatesWithLimit(lnftValue, laneDistanceValue)
    })
  }

  const [count, setCount] = useState(undefined)
  const [hasAccessorials, setHasAccessorials] = useState(false)

  useEffect(() => {
    if(hasAccessorials){
      if(count === 0){
        if(formik.values.origin.Zipcode && formik.values.destination.Zipcode && formik.values.freightInfo[0].qty && formik.values.freightInfo[0].weight && id && (formik.values.accessorials.other.length || formik.values.accessorials.destination.length || formik.values.accessorials.origin.length)){
          setCount(count + 1)
          const enabledVendorsFiltered = user?.enabledVendors.filter(vendor => ((formik.values.VOL && vendor.type === 'VOL') || (formik.values.LTL && (vendor.type === 'LTL' || vendor.type === '3PL')) || (formik.values.smallPack && vendor.type === 'SP') || (formik.values.AIR && (vendor.type === 'INTL' || vendor.type === 'AIR')) || (formik.values.expedite && vendor.type === 'GRE')))

          source = cancelToken.source()
          getLNFTandDistance(formik.values, (lnft, laneDistance) => {getRatesWithLimit(formik.values, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, setShowTable, setRates, setLinearProgress, setRatesStopped, source, normalizeParams, selectedUn, "historyLTL", lnft, laneDistance)})
        }
      }
    }else{
      if(count === 0){
        if(formik.values.origin.Zipcode && formik.values.destination.Zipcode && formik.values.freightInfo[0].qty && formik.values.freightInfo[0].weight && id){
          setCount(count + 1)
          const enabledVendorsFiltered = user?.enabledVendors.filter(vendor => ((formik.values.VOL && vendor.type === 'VOL') || (formik.values.LTL && (vendor.type === 'LTL' || vendor.type === '3PL')) || (formik.values.smallPack && vendor.type === 'SP') || (formik.values.AIR && (vendor.type === 'INTL' || vendor.type === 'AIR')) || (formik.values.expedite && vendor.type === 'GRE')))
          
          source = cancelToken.source()
          
          getLNFTandDistance(formik.values, (lnft, laneDistance) => {getRatesWithLimit(formik.values, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, setShowTable, setRates, setLinearProgress, setRatesStopped, source, normalizeParams, selectedUn, "historyLTL", lnft, laneDistance)})
        }
      }
    }
    
    if(id ? linearProgress > 50 : linearProgress > 0){
      source.cancel('Operation canceled by the user.')
      setRatesStopped(true)
      setLinearProgress(0)
      setRates([])
      setNeedRateType(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, JSON.stringify(formik.values.freightInfo.map(({ STC, commodity, ...rest }) => rest)), formik.values.origin, formik.values.destination, formik.values.accessorials, formik.values.pickupDate])

  useEffect(() => {
    setLNFT(0)
    setLaneDistance("")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(formik.values.freightInfo.map(({ STC, commodity, ...rest }) => rest)), formik.values.origin, formik.values.destination])

  useEffect(() => {
    formik.setFieldValue(`accessorials.origin`, selectedAcc.filter(acc => acc.category === 'Origin'))
    formik.setFieldValue(`accessorials.destination`, selectedAcc.filter(acc => acc.category === 'Destination'))
    formik.setFieldValue(`accessorials.other`, selectedAcc.filter(acc => acc.category === 'Other'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAcc])

  const getCode = (value) => {
    return value.length === 3 ? CountryOptions.find(country => country.CodePrimus === value).Code : value
  }

  const getInsuranceValues = (quoteInfo, accessorials) => {
    
    if(quoteInfo.commodityInsurance){
      formik.setFieldValue('commodityInsurance', quoteInfo.commodityInsurance)
      formik.setFieldValue('insuranceAmount', quoteInfo.insuranceAmount)
      formik.setFieldValue('insuranceAddOn', quoteInfo.insuranceAddOn)
      formik.setFieldValue('insuranceFreight', quoteInfo.insuranceFreight)

    //   let payload = {
    //     originCity: quoteInfo.shipper?.city,
    //     originState: quoteInfo.shipper?.state,
    //     originZipcode: quoteInfo.shipper?.zipCode,
    //     originCountry: quoteInfo.shipper?.country,
    //     destinationCity: quoteInfo.consignee?.city,
    //     destinationState: quoteInfo.consignee?.state,
    //     destinationZipcode: quoteInfo.consignee?.zipCode,
    //     destinationCountry: quoteInfo.consignee?.country,
    //     commodityInsurance: quoteInfo?.commodityInsurance,
    //     insuranceAmount: quoteInfo?.insuranceAmount,
    //     insuranceFreight: quoteInfo?.insuranceFreight,
    //     insuranceAddOn: quoteInfo?.insuranceAddOn,
    //     pickupDate: new Date().toISOString().slice(0, 10),
    //     conveyanceType: "LAND"
    // }

      // axios.post(CREATE_QUOTE_REDKIK, 
      //   payload
      // ).then(result => {
      //     if(result.data.data.results.redkikQuoteId) {
      //       debugger
      //       console.log("redkik normal call")
      //       formik.setFieldValue('redkikQuoteId',result.data.data.results.redkikQuoteId)                
      //     }
      // }).catch(error => {
      //     console.log("error getting redkikQuoteId")
      // })

      let acc = user.enabledAccessorials.filter(enabledAcc => enabledAcc.code === 'INS') 
      let isDuplicated = accessorials.find(accesorial => accesorial.id !== acc.id)          
      
      if(!isDuplicated) {   
        accessorials.push(...acc)
      }
    }
  }
  
  useEffect(() => {
    if(id){
      axios.get(`${GET_QUOTE}/${id}`).then(results => {        
        let quoteInfo = results.data.data.results
        let rateType = quoteInfo.vendor.rateType.toLowerCase()

        if(rateType === 'ltl'){
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('AIR', false)
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'small package'){
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('AIR', false)
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'volume'){
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('AIR', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === '3pl'){
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('AIR', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'intl_ltl'){
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'intl_volume'){
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'air'){
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }else if(rateType === 'intl'){
          formik.setFieldValue('VOL', false)
          formik.setFieldValue('LTL', false)
          formik.setFieldValue('smallPack', false)
          formik.setFieldValue('expedite', false)
        }

        formik.setFieldValue('freightInfoUOM.value', quoteInfo?.UOM)
        formik.setFieldValue('freightInfoTotals.symbol', quoteInfo?.UOM === 'US' ? 'lbs' : 'kgs')


        let accessorials = []
        quoteInfo.accessorialsList.forEach(accessorial => {
          let acc = user.enabledAccessorials.filter(enabledAcc => enabledAcc.code === accessorial)
          accessorials.push(...acc)
        })        

        getInsuranceValues(quoteInfo, accessorials)
        
        if(quoteInfo.accessorialsList.length){
          setHasAccessorials(true)
        }

        formik.setFieldValue('origin', {
          City: quoteInfo?.shipper.city,
          Country: getCode(quoteInfo?.shipper.country),
          Name: quoteInfo?.shipper.name,
          State: quoteInfo?.shipper.state,
          Zipcode: quoteInfo?.shipper.zipCode,
          id: quoteInfo?.shipper.id,
          isPort: false,
          isSL: quoteInfo?.shipper.id ? true : false,
          isZipcode: quoteInfo?.shipper.id ? false : true,
          IATACode: quoteInfo?.shipper?.IATA
        })
        setOrigin({
          City: quoteInfo?.shipper.city,
          Country: quoteInfo?.shipper.country.length === 3 ? CountryOptions.filter(con => con.CodePrimus === quoteInfo?.shipper.country)[0]?.Code || quoteInfo?.shipper.country : quoteInfo?.shipper.country,
          Name: quoteInfo?.shipper.name,
          State: quoteInfo?.shipper.state,
          Zipcode: quoteInfo?.shipper.zipCode,
          id: quoteInfo?.shipper.id,
          isPort: false,
          isSL: quoteInfo?.shipper.id ? true : false,
          isZipcode: quoteInfo?.shipper.id ? false : true,
          IATACode: quoteInfo?.shipper?.IATA
        })

        if(quoteInfo?.shipper?.name){
          setZipcodeDestination(`${quoteInfo?.shipper?.name}. ${quoteInfo?.shipper?.city}, ${quoteInfo?.shipper.state} ${quoteInfo?.shipper.zipCode}`)
        }else{
          setZipcodeOrigin((`${quoteInfo?.shipper.city}${quoteInfo?.shipper.city ? ', ' : ''}${quoteInfo?.shipper.state ? quoteInfo?.shipper.state+' ' : ''}${quoteInfo?.shipper.zipCode}`))
        }

        formik.setFieldValue('destination', {
          City: quoteInfo?.consignee.city,
          Country: getCode(quoteInfo?.consignee.country),
          Name: quoteInfo?.consignee.name,
          State: quoteInfo?.consignee.state,
          Zipcode: quoteInfo?.consignee.zipCode,
          id: quoteInfo?.consignee.id,
          isPort: false,
          isSL: quoteInfo?.consignee.id ? true : false,
          isZipcode: quoteInfo?.consignee.id ? false : true,
          IATACode: quoteInfo?.consignee?.IATA
        })
        setDestination({
          City: quoteInfo?.consignee.city,
          Country: quoteInfo?.consignee.country.length === 3 ? CountryOptions.filter(con => con.CodePrimus === quoteInfo?.consignee.country)[0]?.Code || quoteInfo?.consignee.country : quoteInfo?.consignee.country,
          Name: quoteInfo?.consignee.name,
          State: quoteInfo?.consignee.state,
          Zipcode: quoteInfo?.consignee.zipCode,
          id: quoteInfo?.consignee.id,
          isPort: false,
          isSL: quoteInfo?.consignee.id ? true : false,
          isZipcode: quoteInfo?.consignee.id ? false : true,
          IATACode: quoteInfo?.consignee?.IATA
        })

        if(quoteInfo?.destination?.name){
          setZipcodeDestination(`${quoteInfo?.consignee?.name}. ${quoteInfo?.consignee?.city}, ${quoteInfo?.consignee.state} ${quoteInfo?.consignee.zipCode}`)
        }else{
          setZipcodeDestination((`${quoteInfo.consignee.city}${quoteInfo.consignee.city ? ', ' : ''}${quoteInfo.consignee.state ? quoteInfo.consignee.state+' ' : ''}${quoteInfo.consignee.zipCode}`))
        }
        
        formik.setFieldValue('freightInfo', quoteInfo?.freightInfo.map(quote => {          
          return ({
            H: quote.height,
            Hus: '',
            L: quote.length,
            Lus: '',
            STC: '',
            UN: quote.UN,
            W: quote.width,
            Wus: '',
            class: quote.class,
            volume: quote.volume,
            commodity: quote.commodity,
            freightsnapId: quote.freightSnapId ?? quote.freightsnapId ?? null,
            dimType: TypeOptions.find(type => type.value === quote.dimType),
            each: quote.weightType.charAt(0).toUpperCase() + quote.weightType?.slice(1)?.toLowerCase(),
            hazmat: quote.hazmat,
            id: uuidv4(),
            nmfc: quote.nmfc,
            qty: quote.qty,
            totalCft: parseInt(quote.qty)*(Number(quote.length)*Number(quote.width)*Number(quote.height)/1728),
            weight: quote.weight,
            weightus: ''
          })
        }))


        formik.setFieldValue(`accessorials.origin`, accessorials.filter(acc => acc.category === 'Origin'))
        formik.setFieldValue(`accessorials.destination`, accessorials.filter(acc => acc.category === 'Destination'))
        formik.setFieldValue(`accessorials.other`, accessorials.filter(acc => acc.category === 'Other'))

        setCount(0)

        formik.setFieldValue('moneyAccessorialsInformation', accessorials.map(a => {
          if(a.code === 'INS') {
            return ({
              commodityInsurance: a.code === 'INS'? quoteInfo?.commodityInsurance : undefined,
              insuranceAmount: quoteInfo?.insuranceAmount,
              insuranceAddOn: a.code === 'INS'? quoteInfo?.insuranceAddOn : false,
              insuranceFreight: a.code === 'INS' ? quoteInfo?.insuranceFreight : false,
              accId: a.id,
              typeName: a.typeName
            })
          }
        }))

        setSelectedAcc(accessorials)
      }).catch(error => {
        checkErrorAPICall(error, dispatch, 'Shipping Location')
      })
    }
    
    setHistoryElement(<HistorySelect
      historyFor={'LTL'}
      setDataFormik={formik.setFieldValue}
      setSelectedAcc={setSelectedAcc}
      setOrigin={setOrigin}
      setDestination={setDestination}
      setSelectedUn={setSelectedUn}
    />)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const setDefaultValues = () => {
    ['shipper', 'consignee'].forEach((location) => {
      formik.setFieldValue(location === 'shipper' ? 'origin' : 'destination', {
        City: newBookingValues[location]?.city || '',
        Country: newBookingValues[location]?.country || '',
        Name: newBookingValues[location]?.name || '',
        State: newBookingValues[location]?.state || '',
        Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
        id: newBookingValues[location]?.id || '',
        isPort: false,
        isSL: newBookingValues[location]?.name ? true : false,
        isZipcode: !newBookingValues[location]?.name ? true : false,
        OpenTime: newBookingValues[location]?.opentime,
        CloseTime: newBookingValues[location]?.closetime
      })

      if(newBookingValues[location]?.id){
        if(location === 'shipper'){
          setOrigin({
            City: newBookingValues[location]?.city || '',
            Country: newBookingValues[location]?.country?.length > 2 ? CountryOptions?.find(c => c.CodePrimus === newBookingValues[location]?.country)?.Code || "US" : newBookingValues[location]?.country,
            Name: newBookingValues[location]?.name || '',
            State: newBookingValues[location]?.state || '',
            Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
            id: newBookingValues[location]?.id || '',
            isPort: false,
            isSL: newBookingValues[location]?.name ? true : false,
            isZipcode: !newBookingValues[location]?.name ? true : false,
            OpenTime: newBookingValues[location]?.opentime,
            CloseTime: newBookingValues[location]?.closetime
          })
          setZipcodeOrigin(`${newBookingValues[location]?.name}. ${newBookingValues[location]?.city}, ${newBookingValues[location]?.state} ${newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode}`)
        }else{
          setDestination({
            City: newBookingValues[location]?.city || '',
            Country: newBookingValues[location]?.country?.length > 2 ? CountryOptions?.find(c => c.CodePrimus === newBookingValues[location]?.country)?.Code || "US" : newBookingValues[location]?.country,
            Name: newBookingValues[location]?.name || '',
            State: newBookingValues[location]?.state || '',
            Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
            id: newBookingValues[location]?.id || '',
            isPort: false,
            isSL: newBookingValues[location]?.name ? true : false,
            isZipcode: !newBookingValues[location]?.name ? true : false,
            OpenTime: newBookingValues[location]?.opentime,
            CloseTime: newBookingValues[location]?.closetime
          })
          setZipcodeDestination(`${newBookingValues[location]?.name}. ${newBookingValues[location]?.city}, ${newBookingValues[location]?.state} ${newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode}`)
        }
      }
      
      formik.setFieldValue(`freightInfo`, newBookingValues?.freightInfo.length
        ? newBookingValues?.freightInfo
        : [{
          id: uuidv4(),
          qty: '',
          dimType: {
          name: "PALLET",
          value: "PLT"
          },
          STC: '',
          weight: '',
          each: 'Each',
          L: '',
          W: '',
          H: '',
          class: '',
          commodity: '',
          nmfc: '',
          weightus: '',
          Lus: '',
          Wus: '',
          Hus: '',
          totalCft: '',
          hazmat: false,
          UN: ''
        }]
      )

      let accessorials = []
      if(newBookingValues?.accessorials?.length){
        newBookingValues?.accessorials?.forEach(accessorial => {
          let acc = user.enabledAccessorials.filter(enabledAcc => enabledAcc.code === accessorial)
          accessorials.push(...acc)
        })
      }
  
      formik.setFieldValue(`accessorials.origin`, accessorials.filter(acc => acc.category === 'Origin'))
      formik.setFieldValue(`accessorials.destination`, accessorials.filter(acc => acc.category === 'Destination'))
      formik.setFieldValue(`accessorials.other`, accessorials.filter(acc => acc.category === 'Other'))
      setSelectedAcc(accessorials)
    })
  }

  useEffect(() => {
    if(resetValues){
      formik.resetForm()
      setOrigin({
        City: "",
        Country: "",
        Name: "",
        State: "",
        Zipcode: "",
        isSL: false,
        isZipcode: false,
        id: null
      })
      setZipcodeOrigin('')
      setDestination({
        City: "",
        Country: "",
        Name: "",
        State: "",
        Zipcode: "",
        isSL: false,
        isZipcode: false,
        id: null
      })
      setZipcodeDestination('')
      setDefaultValues()
      setShowTable(false)
      dispatch({type: actionTypes.SetResetValues, payload: false})
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetValues])

  useEffect(() => {
    setDefaultValues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newBookingValues, resetValues])

  useEffect(() => {
    if(formik.errors?.origin?.Zipcode){
      if(formik.values.origin.Zipcode || getCountriesWithoutZipcodes().includes(formik.values.origin.Country)){
        formik.setFieldError(`origin.Zipcode`, '')
      }
    }

    if(formik.errors?.destination?.Zipcode){
      if(formik.values.destination.Zipcode || getCountriesWithoutZipcodes().includes(formik.values.destination.Country)){
        formik.setFieldError(`destination.Zipcode`, '')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.errors])

  useEffect(() => {
    if(!formik?.values?.freightInfo[0]?.UN || !formik?.values?.freightInfo[0]?.hazmat) {
      setSelectedUn([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.freightInfo]);

  useEffect(() => {
    window.addEventListener('click', (e) => {
      if(e?.target?.id !== 'fieldAccessorials' && !e.target.getAttribute("d")){
        setCloseAcc(true)
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <div style={{marginRight: window.innerWidth > 991 && (fontSize === 9 ? 300 : fontSize === 11 ? 210 : 0)}}>
      <PageTitle>Get Quote</PageTitle>
      <form
        onSubmit={formik.handleSubmit}
      >
        <div className="form-group row">
          <label className={`col-xl-1 col-form-label ${marginSize(fontSize, 'mt-2','')}`}>Origin</label>
          <ZipcodesWithCountry
            zipcodeLocal={zipcodeOrigin}
            setZipcodeLocal={setZipcodeOrigin}
            valueName={'origin'}
            setDataFormik={formik.setFieldValue}
            formikValues={formik.values}
            data={origin}
            setData={setOrigin}
            countryOptions={CountryOptions}
            userData={user}
            error={formik?.errors?.origin?.Zipcode}
            touched={formik?.touched?.origin}
            setFieldTouched={formik.setFieldTouched}
            setFieldError={formik.setFieldError}
          />
          <label className={`col-xl-1 col-form-label ${marginSize(fontSize, 'mt-2','')}`}>Destination</label>
          <ZipcodesWithCountry
            zipcodeLocal={zipcodeDestination}
            setZipcodeLocal={setZipcodeDestination}
            valueName={'destination'}
            setDataFormik={formik.setFieldValue}
            formikValues={formik.values}
            data={destination}
            setData={setDestination}
            countryOptions={CountryOptions}
            userData={user}
            error={formik?.errors?.destination?.Zipcode}
            touched={formik?.touched?.destination}
            setFieldTouched={formik.setFieldTouched}
            setFieldError={formik.setFieldError}
          />
          <label className={`col-xl-1 col-form-label ${marginSize(fontSize, 'mt-2','')}`}>Pickup Date</label>
          <div className={`col-sm-8 col-md-7 col-xl-3 mb-2 mb-xl-0`}>
            <DateInput
              setDataFormik={formik.setFieldValue}
              pickupDate={formik.values.pickupDate}
              error={formik.errors.pickupDate}
              touched={touchedPickupDate}
              setTouched={setTouchedPickupDate}
              allowPastDates={false}
            />
            {(formik.errors.pickupDate && touchedPickupDate) && <small className="text-danger ms-1">
              {(formik.errors.pickupDate as string)?.includes('must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).') && 'Invalid date'}
              {formik.errors.pickupDate === 'Pickup date cannot be in the past' && formik.errors.pickupDate}
              {!formik.values.pickupDate && 'Required'}
            </small>}
          </div>
        </div> 
        {fontSize >= 13 && <div className={`form-group row`}>
          <label className="col-sm-12 col-xl-1 col-form-label">Freight Info</label>
        </div>}
        <div style={{  backgroundColor: 'rgb(228, 230, 239)', borderRadius: '0.475rem',border: '1px solid #E4E6EF', padding: '10px 20px', marginBottom: '10px'}}>
          {
            formik.values.freightInfo?.map((freight, index) => {
              return(
                <div className={`form-group row align-items-start ${index === formik.values.freightInfo.length - 1 && 'mb-2'}`} key={freight.id}>
                  {fontSize < 13 && <div className="col-12 col-xl-1 mt-5">
                    {index === 0 && <label className="col-form-label">Freight Info</label>}
                  </div>}
                  <div className={`${fontSize < 13 ? 'col-12 col-xl-11 mt-5' : 'col-12'}`}>
                    <div className="row g-0">
                      <FreightInformation
                        index={index}
                        freight={freight}
                        freightInfo={formik.values.freightInfo}
                        freightInfoUOM={formik.values.freightInfoUOM}
                        handleChange={formik.handleChange}
                        setDataFormik={formik.setFieldValue}
                        formik={formik}
                        errors={formik.errors.freightInfo && (formik.errors.freightInfo[index] as freightErrors)}
                        touched={formik?.touched?.freightInfo && formik?.touched?.freightInfo[index]}
                        setOpenHazContactModal={setOpenHazContactModal}
                        setSelectedUn={setSelectedUn}
                        selectedUn={selectedUn}
                      />
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className={`form-group row g-0 ${marginSize(fontSize, 'mb-2', 'mb-xl-3')}`}>
          <FreightTotals 
            freightInfoTotals={formik.values.freightInfoTotals}
            freightInfo={formik.values.freightInfo}
            freightInfoUOM={formik.values.freightInfoUOM}
            setDataFormik={formik.setFieldValue}
          />
          <SelectUOM
            freightInfoUOM={formik.values.freightInfoUOM}
            setDataFormik={formik.setFieldValue}
            freightInfo={formik.values.freightInfo}
            freightInfoTotals={formik.values.freightInfoTotals}
            readOnly={user?.disableMetricDataEntry}
          />
        </div>
        {/* ${marginSize(fontSize, 'mb-10', 'mb-5')} */}
        <div className="form-group row align-items-center">
          <label className={`col-xl-1 col-sm-12 col-form-label`}>Accessorials</label>
          <div className={`col-xl-5 col-sm-12`} style={{position: 'relative'}}>
            <Accessorials setIsAccesorialsOpenend={setIsAccesorialsOpenend} closeAcc={closeAcc} setOpenErrorsInPageModal={setOpenErrorsInPageModal} setCloseAcc={setCloseAcc} formik={formik} formikValues={formik.values} setFormikValues={formik.setFieldValue} selectedAcc={selectedAcc} setSelectedAcc={setSelectedAcc} accessorialsList={user?.enabledAccessorials?.filter(accessorial => accessorial.rateTypes?.includes('LTL'))?.filter(accessorial => accessorial.code !== 'HAZ')} actionClicked={actionClicked}/>
          </div>

          <div className="col-xl-6 col-sm-12 mt-4 mt-xl-0 d-flex justify-content-end align-items-center">
            {
              needRateType
              ? <span className="text-danger me-5">Please select at least 1 rate type</span>
              : null
            }
            <div className='d-flex justify-content-end w-100'>
              <div className='w-25'>
                <SwitchLTL {...formik.getFieldProps('VOL')} title="Volume"/>
              </div>
              <div className='w-25'>
                <SwitchLTL {...formik.getFieldProps('smallPack')} title="Small Pack"/>
              </div>
              <div className='w-25'>
                <SwitchLTL {...formik.getFieldProps('LTL')} title="LTL"/>
              </div>
              <div className='w-25'>
                <SwitchLTL {...formik.getFieldProps('AIR')} title="AIR"/>
              </div>
              <div className='w-25'>
                <SwitchLTL {...formik.getFieldProps('expedite')} title="Expedite"/>
              </div>
            </div>
            
          </div>
        </div>
        <div className={`row align-items-center justify-content-end ${!user?.expandAccessorials ? 'mt-3' : ''}`} style={{ marginTop: isAccesorialsOpenend ? '180px' : '10px' }}>
        	  <div className='col-12 col-md-8 col-sm-6 d-flex'>
	            {
	              !needRateType
	              ? <div style={{color: '#3F4254'}}>
	                  {LNFT ? <><span style={{fontWeight: 500}}>Approx. LNFT:</span> {LNFT} {laneDistance ? '-' : null} </> : null}
                    {laneDistance ? <><span style={{fontWeight: 500}}>Distance:</span> {laneDistance}</> : null}
	                </div>
	              : null
	            }
            </div>

            <div className="col-12 col-md-4 col-sm-6 d-flex justify-content-end mt-7 mt-sm-0">
              <button
                type="button"
                className='btn btn-danger me-4'
                onClick={() => {
                  formik.resetForm()
                  setShowTable(false)
                  setZipcodeOrigin('')
                  setZipcodeDestination('')
                  setSelectedAcc([])
                  formik.setErrors({})
                  formik.setTouched({})
                }}
              >
                Clear
              </button>
              <button
                type='submit'
                className='btn btn-primary'
                onClick={() => {
                  setActionClicked(!actionClicked)
                  setVendorsProcessed([])
                  setTouchedPickupDate(true)
                }}
              >
                Get Rates
              </button>
            </div>
        </div>
      </form>
      {
        showTable ? 
        <RatesTable
          vendorsFiltered={enabledVendors}
          vendorsProcessed={vendorsProcessed}
          tableFor={'LTL'}
          ratesStopped={ratesStopped}
          setRatesStopped={setRatesStopped}
          source={source}
          linearProgress={linearProgress}
          rates={rates}
          origin={formik?.values?.origin}
          destination={formik?.values?.destination}
          values={formik.values}
          selectedUn={selectedUn}
        />
        : null
      }
      <InsuranceRequiredModal
        open={openInsuranceRequiredModal}
        setOpen={setOpenInsuranceRequiredModal}
      />
      <ConfirmTimedOutVendorsModal
        open={openConfirmTimedOutModal}
        setOpen={setOpenConfirmTimedOutModal}
        vendorsTimedOut={vendorsTimedOut}
        keepWaitingVendors={() => {
          source = cancelToken.source()
          keepWaitingVendors(user, rates, linearProgress, setLinearProgress, vendorsTimedOut, setVendorsTimedOut, vendorsProcessed, setVendorsProcessed, setRatesStopped, enabledVendors, setRates, setOpenConfirmTimedOutModal, source, normalizeParams)
        }}
        formikValues={formik.values}
      />
      <NoVendorsSetUpModal
        open={openNoVendorsSetUpModal}
        setOpen={setOpenNoVendorsSetUpModal}
      />

      <ErrorsInPageModal
        open={openErrorsInPageModal}
        setOpen={setOpenErrorsInPageModal}
        lockedBOL={user.lockedBOL}
        setLoadingDispatchShipment={setLoadingDispatchShipment}
      />

      <EquipmentServiceModal
        open={openEquipmentServiceModal}
        setOpen={setOpenEquipmentServiceModal}
        formik={formik}
        getRates={() => {          
          let values = formik.values
          let enabledVendorsFiltered = user.enabledVendors.filter(vendor => ((values.VOL && vendor.type === 'VOL') || (values.LTL && (vendor.type === 'LTL' || vendor.type === '3PL')) || (values.smallPack && vendor.type === 'SP') || (values.AIR && (vendor.type === 'INTL' || vendor.type === 'AIR')) || (values.expedite && vendor.type === 'GRE')))
          
          setNeedRateType(false)
          source = cancelToken.source()

          let subVendors = []
          if(!enabledVendorsFiltered.length){
            if(values.smallPack){
              user.enabledVendors.forEach(vendor => {
                let subVendorsSP = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'SP')
                if(subVendorsSP.length){
                  subVendors.push(...subVendorsSP)
                  enabledVendorsFiltered = subVendors
                }
              })
            }

            if(values.expedite){
              user.enabledVendors.forEach(vendor => {
                let subVendorsSP = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'GRE')
                if(subVendorsSP.length){
                  subVendors.push(...subVendorsSP)
                  enabledVendorsFiltered = subVendors
                }
              })
            }

            if(values.LTL){
              user.enabledVendors.forEach(vendor => {
                let subVendorsLTL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'LTL' || subVendor?.carrierType === '3PL')
                if(subVendorsLTL.length){
                  subVendors.push(...subVendorsLTL)
                  enabledVendorsFiltered = subVendors
                }
              })
            }

            if(values.VOL){
              user.enabledVendors.forEach(vendor => {
                let subVendorsVOL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'VOL')
                if(subVendorsVOL.length){
                  subVendors.push(...subVendorsVOL)
                  enabledVendorsFiltered = subVendors
                }
              })
            }

            if(values.AIR){
              user.enabledVendors.forEach(vendor => {
                let subVendorsAIR = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'INTL' || subVendor?.carrierType === 'AIR')
                if(subVendorsAIR.length){
                  subVendors.push(...subVendorsAIR)
                  enabledVendorsFiltered = subVendors
                }
              })
            }
          }

          getRatesWithLimit(values, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, setShowTable, setRates, setLinearProgress, setRatesStopped, source, normalizeParams, selectedUn, 'historyLTL')
        }}
      />
  </div>
  )
}